import { WebpActionTypes } from "../models";
import { SET_WEBP } from "../types";

export default (webp = true, action: WebpActionTypes): boolean => {
    const { payload } = action;
    switch (action.type) {
        case SET_WEBP:
            return payload;
        default:
            return webp;
    }
};
